import { isNonNull, objectAttributes } from './helper';
export const convertTemplateAreas = function () {
  let areas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return areas && areas.map(area => `"${area}"`).join('\n');
};
export const convertPropsToStyle = function (matchedBreakpoints) {
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const gridStyles = {};
  const reactProps = {};
  for (let key in props) {
    if (!gridStyleProps[key]) {
      const propValue = getResponsiveProp(key, props[key], matchedBreakpoints);
      if (propValue) {
        reactProps[key] = propValue;
      }
    } else {
      const gridPropertyEntry = gridStyleProps[key];
      const gridPropValue = getResponsiveProp(key, props[key], matchedBreakpoints);
      const [gridCSSProperty, convert] = gridPropertyEntry;
      const gridCSSValue = convert ? convert(gridPropValue) : gridPropValue;
      gridStyles[gridCSSProperty] = gridCSSValue;
    }
  }
  return {
    gridStyles,
    reactProps
  };
};
export const isObjectAttribute = function () {
  let propName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (
    // checks if the prop name (if non-null) passed is an html attribute that can accept an object
    // as value, when used with JSX
    propName ? objectAttributes.some(attr => propName.startsWith(attr)) : false
  );
};
export const getResponsiveProp = function (key, prop) {
  let matchedBreakpoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['S'];
  if (prop && typeof prop === 'object' && !Array.isArray(prop) && !isObjectAttribute(key)) {
    for (let breakpoint of matchedBreakpoints) {
      if (isNonNull(prop[breakpoint])) {
        return prop[breakpoint];
      }
    }
    return prop.S;
  }
  return prop;
};
const gridStyleProps = {
  areas: ['gridTemplateAreas', convertTemplateAreas],
  gridArea: ['gridArea'],
  columns: ['gridTemplateColumns'],
  rows: ['gridTemplateRows'],
  gutter: ['gap'],
  rowGutter: ['rowGap'],
  colGutter: ['columnGap'],
  margin: ['margin']
};